export default __webpack_public_path__ + "static/media/sprout.855e6307.png";